import { useMsal } from '@azure/msal-react';
import React, { useState } from 'react';
import { IBasket, IBasketContext } from '../interfaces';

export const BasketContext = React.createContext<IBasketContext>({
    basket: { items: [] },
    setBasket: () => { },
    clearBasket: () => { }
});

export const BasketContextProvider: React.FC = ({
    ...props
}) => {

    const { accounts } = useMsal();
    const userId = accounts ? accounts[0].localAccountId : ""

    const getLocalBasket = () => {
        let localBasket = window.localStorage.getItem("basket_" + userId);
        if (localBasket && localBasket.length > 0) {
            return JSON.parse(localBasket) as IBasket;
        } else return { items: [] } as IBasket;
    }
    const setLocalBasket = (b: IBasket) => {
        window.localStorage.setItem("basket_" + userId, JSON.stringify(b));
    }
    const clearLocalBasket = () => {
        window.localStorage.removeItem("basket_" + userId);
    }

    const onSetBasket = (b: IBasket) => {
        setBasket(b);
        setLocalBasket(b);
    }

    const onClearBasket = () => {
        setBasket({ items: [] })
        clearLocalBasket();
    }

    const [basket, setBasket] = useState<IBasket>(getLocalBasket());

    return <BasketContext.Provider value={{
        basket,
        setBasket: onSetBasket,
        clearBasket: onClearBasket
    }} >
        {props.children}
    </BasketContext.Provider >

}
